import { actionCreator, ActionReturnType } from "@itk/typescript-utils";
import { CustomerPut, EditCustomerDialogProps } from "./company-information-types";

export enum Action {
  SetEditCustomerDialogProps = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:COMPANY-INFORMATION:COMPANY-INFORMATION-STORE.TS:ACTION:SETEDITCUSTOMERDIALOGPROPS",
  PutCustomerRequest = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:COMPANY-INFORMATION:COMPANY-INFORMATION-STORE.TS:ACTION:PUTCUSTOMERREQUEST",
  Clear = "@@ITK:SRC:PAGES:INFORMATION:COMPONENTS:COMPANY-INFORMATION:COMPANY-INFORMATION-STORE.TS:ACTION:CLEAR"
}

type CustomerState = {
  editDialogProps: EditCustomerDialogProps | undefined;
};

const initialState: CustomerState = {
  editDialogProps: undefined
};

export const companyInformationActions = {
  setEditCustomerDialogProps: (data: EditCustomerDialogProps | undefined) => actionCreator(Action.SetEditCustomerDialogProps, { data }),
  putCustomerRequest: (customerId: string, data: CustomerPut) => actionCreator(Action.PutCustomerRequest, { customerId, data }),
  clear: () => actionCreator(Action.Clear)
};

export const companyInformationReducer = (state = initialState, action: ActionReturnType<typeof companyInformationActions>): CustomerState => {
  switch (action.type) {
    case Action.SetEditCustomerDialogProps:
      return { ...state, editDialogProps: action.payload.data };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
